export const fetch_available_sessions_api = "host/open/sessions";
export const fetch_appointment_listing_details_api =
  "host/customer/booked/sessions";
export const reschedule_appointment_session_api =
  "host/reschedule/customer/session";
export const schedule_appointment_session_api =
  "host/schedule/customer/session";
